import queryString from "query-string";
import { useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";
import { UrlQueryParams } from "store/types";

interface IUseUrlHooks {
  queryParams: UrlQueryParams & IQueryParams;
  routeParams: IRouteParams;
}

interface IQueryParams {
  [key: string]: any;
}

interface IRouteParams {
  [key: string]: string;
}

export function useUrlHooks(): IUseUrlHooks {
  const { location } = useHistory();
  const routeParams = useParams();
  const filteredEmail = location.search.replace(/(email.+)\+/g, "%2B");

  const queryParams: UrlQueryParams = useMemo(() => {
    return queryString.parseUrl(filteredEmail).query;
  }, [filteredEmail]);

  return {
    queryParams,
    routeParams
  };
}
